import { Box, useTheme } from '@mui/material';
import { Heading } from '../Heading/Heading';
import { Text } from '../Text/Text';
import { Button } from '../Button/Button';
import { buttonSx } from '../../styles/Global.style';
import {
  confirmationBtnContainerSx,
  confirmationBtnSx,
  confirmationContentSx,
  confirmationHeadingSx,
} from './Confirmation.style';

export const Confirmation = ({
  title,
  content,
  acceptBtnText,
  declineBtnText,
  decline,
  accept,
}) => {
  const theme = useTheme();
  const color = theme.palette.secondary.main;

  return (
    <Box>
      <Heading
        level={1}
        text={title}
        color={color}
        sx={confirmationHeadingSx}
      />

      <Text text={content} color={color} sx={confirmationContentSx} />

      <Box sx={confirmationBtnContainerSx}>
        <Button
          text={declineBtnText}
          onClick={decline}
          sx={{ ...buttonSx(theme), ...confirmationBtnSx }}
        />
        <Button
          text={acceptBtnText}
          onClick={accept}
          sx={{ ...buttonSx(theme), ...confirmationBtnSx }}
        />
      </Box>
    </Box>
  );
};
